import type { EmailForwarding } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllEmailForwardings = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    emailForwardings: EmailForwarding[];
  }>(GET_ALL_EMAIL_FORWARDINGS, {
    variables: { tenantId },
    skip: !enabled,
  });

  return {
    emailForwardings: data?.emailForwardings ?? [],
    error,
    loading,
    refetch,
  };
};

export const GET_ALL_EMAIL_FORWARDINGS = gql`
  query GetAllEmailForwardings($tenantId: String!) {
    emailForwardings(tenantId: $tenantId) {
      emailForwardingId
      forwardingAddress
      isActive
      alias
      description
      createdAt
      updatedAt
    }
  }
`;
